import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';

import IconArrowRightBold from 'components/icons/IconArrowRightBold';

const styles = theme => ({
  root: {
    display: 'block',
    width: '100%',
    height: '100%',
    borderRadius: 10,
    color: theme.palette.primary[500],
    '&:hover, &:focus': {
      '& $paper': {
        borderColor: theme.palette.primary[500],
      },
      '& $iconArrowRightBold': {
        transform: 'translateX(5px)',
      },
    },
  },
  paper: {
    boxSizing: 'border-box',
    minHeight: 53,
    height: '100%',
    padding: '8px 8px 8px 48px',
    border: `1px solid ${theme.palette.common.white}`,
    transition: theme.transitions.create(['border-color'], {
      duration: theme.transitions.duration.short,
    }),
  },
  iconArrowRightBold: {
    width: 12,
    height: 10,
    margin: '5px 0 0 4px',
    verticalAlign: 'top',
    transform: 'translateX(0)',
    transition: theme.transitions.create(['transform'], {
      duration: theme.transitions.duration.short,
    }),
  },
  icon: {
    position: 'absolute',
    left: 0,
    bottom: 0,
    maxHeight: '100%',
    borderBottomLeftRadius: 10,
    overflow: 'hidden',
  },
});

const QuickNavigationItem = ({
  title,
  text,
  icon,
  href,
  onClick,
  history,
  target,
  staticContext,
  classes,
}) => (
  <ButtonBase
    className={classes.root}
    target={target}
    {...href && staticContext ? { href } : {}}
    rel="noopener"
    onClick={href && target !== '_blank'
      ? () => {
        onClick();
        if (href !== history.location.pathname) {
          history.push(href);
        }
      }
      : onClick
    }
  >
    <Paper className={classes.paper}>
      <Typography
        // variant="caption"
        color="primary"
        align="left"
      >
        {title}
        <IconArrowRightBold className={classes.iconArrowRightBold} />
      </Typography>
{/*      <Typography
        variant="caption"
        align="left"
      >
        {text}
      </Typography>*/}
      {icon &&
        <div className={classes.icon}>
          {icon}
        </div>
      }
    </Paper>
  </ButtonBase>
);

QuickNavigationItem.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  icon: PropTypes.node,
  href: PropTypes.string,
  onClick: PropTypes.func,
  target: PropTypes.oneOf(['_blank', '_self']),
  staticContext: PropTypes.bool,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    paper: PropTypes.string.isRequired,
    iconArrowRightBold: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
  }).isRequired,
};

QuickNavigationItem.defaultProps = {
  text: null,
  icon: null,
  href: null,
  onClick: () => {},
  target: '_self',
  staticContext: true,
};

export default withRouter(
  withStyles(styles)(QuickNavigationItem),
);



// WEBPACK FOOTER //
// ./src/components/home/QuickNavigation/QuickNavigationItem.js